/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { ToastData, ToastType } from "../components/toast/toast-data.model";
import { ToastComponent } from "../components/toast/toast.component";

@Injectable({
	providedIn: "root"
})
export class ToastService {
	private readonly _duration = 5000;

	constructor(private _snackBar: MatSnackBar) {}

	public success(title: string, message: string = ""): void {
		this._open("success", title, message);
	}

	public warning(title: string, message: string = ""): void {
		this._open("warning", title, message);
	}

	public error(title: string, message: string = ""): void {
		this._open("error", title, message);
	}

	private _open(type: ToastType, title: string, message: string): void {
		const data: ToastData = {
			type,
			title,
			message,
			duration: this._duration
		};

		const config: MatSnackBarConfig<ToastData> = {
			data,
			duration: this._duration,
			horizontalPosition: "left",
			verticalPosition: "bottom",
			panelClass: ["toast-panel", `toast-panel-${type}`]
		};

		this._snackBar.openFromComponent(ToastComponent, config);
	}
}
